export default __webpack_public_path__ + "static/media/image-9.b31d7f31.jpeg";